import { gql } from "@apollo/client";

export const getUserPool = gql`
  query getUserPool($input: MultitenancyInput) {
    getCompanyUserpool(input: $input) {
      theme
      userpoolDetails {
        userPoolId
        clientId
        region
      }
      passwordComplexity
    }
  }
`;

export const getCompany = gql`
  query getCompany($id: ID!) {
    sizeOfOrganization(id: $id) {
      id
      tenantId
      name
      profile {
        links {
          type
          url
        }
        logo {
          region
          bucket
          url
          uploadUrl
          fileName
        }
        address {
          address
          city
          state
          zipcode
          country
        }
        contactNumber
        logo {
          bucket
          key
          region
          url
          uploadUrl
        }
        sizeOfOrganization
        reasonOfUsage
        primaryIndustry
        otherReasonOfUsage
      }
      onBoarding
      onboardingQuestions {
        question
        answer
        isSelected
        isDefault
        isDeleted
      }
      theme
      status
    }
  }
`;

export const listCompanys = gql`
  query listCompanys(
    $filter: ModelCompanyFilterInput
    $userFilter: ModelUserFilterInput
  ) {
    listCompanys(filter: $filter) {
      items {
        id
        name
        tenantId
        allUsers(filter: { status: { eq: ACTIVE } }) {
          items {
            id
            firstName
            lastName
          }
        }
        profile {
          contactNumber
          address {
            addressaddress
            city
            state
            zipcode
            country
          }
          links {
            type
            url
          }
          logo {
            key
            url
            uploadUrl
            fileName
          }
          sizeOfOrganization
          reasonOfUsage
          primaryIndustry
          otherReasonOfUsage
        }
        theme
        imprint {
          termsAndConditions {
            version
            latest
            createdAt
            terms
            url
          }
        }
        config {
          passwordPolicy {
            complexity
          }
          departments
          designations
          locations
          setUpMessages {
            loginWelcome
          }
        }
        feature {
          target {
            type
            name
            isEnabled
            color
          }
          checkin {
            type
            name
            isEnabled
          }
          myTeam
          communication
          library
        }
        onBoarding
        onboardingQuestions {
          question
          answer
          isSelected
          isDefault
          isDeleted
        }
        performanceCycle {
          items {
            id
            type
            Name
            srNo
            yearStartDate
            yearEndDate
            cycleStartDate
            cycleEndDate
            weightageType
          }
        }
        users(filter: $userFilter) {
          items {
            id
            eeid
            firstName
            lastName
            role
            department
            location
            status
            designation
            managingDepartment
            hireDate
            profile {
              email
            }
            strengths {
              category
              strengths
            }
            supervisor {
              id
              firstName
              lastName
            }
          }
        }
        companyId
      }
    }
  }
`;

export const udpatedCompanyConfig = gql`
 query getCompany($id: ID!) {
    getCompany(id: $id) {
      id
      config {
        departments
        designations
        locations
      }
      companyId
    }
  }
`;